import _ from 'lodash';
import { axiosInstance } from '../helpers';
import { userService } from './user.service';

const findOne = referralId => {
  return axiosInstance
    .get(`/referrals/${referralId}`)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
};

const findAllReferred = (referralId, codes, boughtPlan) => {
  const params = {};
  if (codes) params.codes = codes;
  if (boughtPlan) params.boughtPlan = boughtPlan;
  return axiosInstance
    .get(`/referrals/${referralId}/users`, { params })
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
};

const handleResponse = response => {
  const data = response.data;
  if (!_.includes([200, 201, 204], response.status)) {
    if (response.status === 401 && !response.config.url.includes('/users/login')) {
      // auto logout if 401 response returned from api
      userService.logout().then(() => window.location.reload(true));
    }

    const error = (data && data.message) || response.statusText;

    // eslint-disable-next-line no-throw-literal
    throw { status: response.status, error };
  }

  return data;
};

const getAllReferrals = () => {
  return axiosInstance
    .get(`/referrals/`)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
}

const createReferral = (referral) => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: referral,
  };

  return axiosInstance
    .post(`/referrals`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
}

const updateReferral = (referral) => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: referral,
  };

  return axiosInstance
    .patch(`/referrals/${referral.id}`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
}

const addCode = (referralId, code) => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: code,
  };

  return axiosInstance
    .post(`/referrals/${referralId}/codes`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
}

const updateCode = (referralId, codeId, code) => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: code,
  };

  return axiosInstance
    .patch(`/referrals/${referralId}/codes/${codeId}`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
}

export const referralService = {
  findOne,
  findAllReferred,
  getAllReferrals,
  createReferral,
  updateReferral,
  addCode,
  updateCode,
};
